import { desEncrypt, desDecrypt, resetGetTokenSign } from "./sign.js";
import { formatTime } from "../time.js";

/**
 * 获取sign
 */
export const getSign = (ztId: string) => {
  let currentDate = formatTime(new Date());
  return resetGetTokenSign(desEncrypt(`${ztId}&${currentDate}&123456`), ztId);
};

export const getURL = (tokenParams: any) => {
  return setUrlParam("tokenParams", escape(JSON.stringify(tokenParams)));
};

const setUrlParam = (name: string, value: string) => {
  const Days = 30;
  const exp = new Date();
  exp.setTime(exp.getTime() + Days * 24 * 60 * 60 * 1000); //.91yikuaiji.com
  return "?" + name + "=" + value + "&path=/";
};
